import './SettingsPage.css';
import { useState } from 'react';
import { toast } from 'react-toastify';
import serviceOrderApi from '../../../services/apiServices/serviceOrderApi';
import UpdatePasswordModal from '../../../components/common/Modals/UpdatePasswordModal/UpdatePasswordModal';

const SettingsPage = () => {
    const [loading, setLoading] = useState(false);
    const [showPasswordModal, setShowPasswordModal] = useState(false);

    const handleRequestService = async () => {
        try {
            setLoading(true);
            const result = await serviceOrderApi.requestService();
            const total = result?.length || 0;
            toast.success(`${total} pedidos foram expirados.`);
        } catch (error) {
            toast.error('Erro ao acionar o serviço.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="container-admin-page">
            <h1>Configurações</h1>
            <div className="settings-buttons">
                <button className="main-button" onClick={() => setShowPasswordModal(true)}>
                    Alterar Senha
                </button>
                <button className="main-button" onClick={handleRequestService} disabled={loading}>
                    {loading ? 'Aguardando...' : 'Acionar Serviço de Expiração de Pedidos'}
                </button>
            </div>

            <UpdatePasswordModal
                isOpen={showPasswordModal}
                onClose={() => setShowPasswordModal(false)}
            />
        </div>
    );
};

export default SettingsPage;
